import { toDigits } from './toDigits';

const AREA_END = 3;
const GROUP_END = 5;
const SSN_DIGITS = 9;

export const toSSNString = (value?: string | number | null): string => {
  const digits = toDigits(value).slice(0, SSN_DIGITS);

  if (digits.length === 0) {
    return '';
  }

  if (digits.length <= AREA_END) {
    return digits;
  }

  if (digits.length <= GROUP_END) {
    return `${digits.slice(0, AREA_END)}-${digits.slice(AREA_END)}`;
  }

  return `${digits.slice(0, AREA_END)}-${digits.slice(
    AREA_END,
    GROUP_END,
  )}-${digits.slice(GROUP_END)}`;
};
